import React from 'react';
import Icon from '../../../components/AppIcon';

const AddressDetailsCard = ({ address, balance, firstActivity, lastActivity, transactionCount, riskScore }) => {
  const getRiskColor = (score) => {
    if (score >= 80) return 'text-error bg-red-50 border-red-200';
    if (score >= 60) return 'text-warning bg-amber-50 border-amber-200';
    if (score >= 40) return 'text-accent bg-yellow-50 border-yellow-200';
    return 'text-success bg-green-50 border-green-200';
  };

  const getRiskLabel = (score) => {
    if (score >= 80) return 'High Risk';
    if (score >= 60) return 'Medium-High Risk';
    if (score >= 40) return 'Medium Risk';
    return 'Low Risk';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-forensic-card">
      <div className="flex items-start justify-between mb-6">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-text-primary mb-2">Address Details</h3>
          <div className="font-data text-sm text-text-secondary bg-muted p-3 rounded-lg break-all">
            {address}
          </div>
        </div>
        <div className={`ml-4 px-4 py-2 rounded-lg border ${getRiskColor(riskScore)}`}>
          <div className="text-center">
            <div className="text-2xl font-bold">{riskScore}</div>
            <div className="text-xs font-medium">{getRiskLabel(riskScore)}</div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-muted p-4 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Wallet" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-text-secondary">Current Balance</span>
          </div>
          <div className="text-lg font-semibold text-text-primary">{balance} BTC</div>
          <div className="text-sm text-text-secondary">≈ $1,247,850.00</div>
        </div>

        <div className="bg-muted p-4 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Activity" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-text-secondary">Transaction Count</span>
          </div>
          <div className="text-lg font-semibold text-text-primary">{transactionCount?.toLocaleString()}</div>
          <div className="text-sm text-text-secondary">Total transactions</div>
        </div>

        <div className="bg-muted p-4 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Calendar" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-text-secondary">First Activity</span>
          </div>
          <div className="text-lg font-semibold text-text-primary">{firstActivity}</div>
          <div className="text-sm text-text-secondary">Initial transaction</div>
        </div>

        <div className="bg-muted p-4 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Clock" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-text-secondary">Last Activity</span>
          </div>
          <div className="text-lg font-semibold text-text-primary">{lastActivity}</div>
          <div className="text-sm text-text-secondary">Recent transaction</div>
        </div>
      </div>
    </div>
  );
};

export default AddressDetailsCard;